import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import mutations from './mutations'
import getter from './getter'

const ua = navigator.userAgent.toLowerCase()
const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isWeixin: /MicroMessenger/i.test(ua),
    user: null,
    // hasToken: false, // 标记这个用户在上一次路由跳转已经获得了登录态，用于在每次路由跳转时节省一次get_access_token的开销
    isOpen: false, // 标记这个用户在上一次路由跳转已经表明这个一个已激活教室的用户， 用于在每次路由跳转时节省一次调用后端接口判断是否激活
    hasParentPhone: false, // 标记这个用户在上一次路由跳转已经表明这个一个已绑定家长手机的用户， 用于在每次路由跳转时节省一次调用后端接口判断是否绑定家长手机号
    viewerUrl: sessionStorage.getItem('currPDF') || '',
    classData: [],
    fromSchool: false // 学院移动端跳转过来
  },
  getter,
  actions,
  mutations,
  plugins: debug ? [createLogger(), createPersistedState()] : [createPersistedState()]
})
